/**
* Common methods for rendering last interaction info
**/
export default {
  methods: {
    lastInteraction: function(patient) {
      if (patient.lastLogin) {
        return 'Login';
      }
      // TODO: Check for last email open or email click when available
      return 'Registration';
    },
    lastInteractionDt: function(patient) {
      if (patient.lastLogin) {
        return patient.lastLogin;
      }
      // TODO: Check for last email open or email click when available
      return patient.createdOn;
    }
  }
};
